"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const navs_1 = __importDefault(require("./modules/navs"));
const copy_text_1 = __importDefault(require("./modules/copy-text"));
const prepain_ads_1 = __importDefault(require("./modules/prepain-ads"));
const habitos_1 = __importDefault(require("./modules/habitos"));
const habitos_tutorial_1 = __importDefault(require("./modules/habitos-tutorial"));
const app_refresh_1 = __importDefault(require("./modules/app-refresh"));
const app_back_1 = __importDefault(require("./modules/app-back"));
const app_sw_1 = __importDefault(require("./modules/app-sw"));
const app_quiz_nav_1 = __importDefault(require("./modules/app-quiz-nav"));
const app_student_id_1 = __importDefault(require("./modules/app-student-id"));
const app_course_tabs_1 = __importDefault(require("./modules/app-course-tabs"));
document.addEventListener("DOMContentLoaded", () => {
    new navs_1.default().init();
    new copy_text_1.default();
    new prepain_ads_1.default().init();
    new habitos_1.default().init();
    new habitos_tutorial_1.default().init();
    new app_refresh_1.default().init();
    new app_back_1.default().init();
    new app_sw_1.default().init();
    new app_quiz_nav_1.default().init();
    new app_student_id_1.default().init();
    new app_course_tabs_1.default().init();
});
